<template>
  <div class="card">
    <h3>Research - Credit Highlights</h3>
    <ul>
      <li v-for="(k, i) in visibleKeys" :key="i">
        <div class="kstrength">{{ k.keyStrength }}</div>
        <div v-if="k.keyRisk" class="krisk">{{ k.keyRisk }}</div>
      </li>
      <li v-if="keys.length===0" class="empty">No key highlights</li>
    </ul>
    <button v-if="showMoreAvailable" class="more" @click="showAll = !showAll" :aria-expanded="showAll" aria-controls="rx-abstract">{{ showAll ? 'Show less' : 'Show more' }}</button>
    <div class="abstract-wrapper" v-if="abstract">
      <div id="rx-abstract" class="abstract" :class="{ collapsed: !showAll }" v-html="abstract"></div>      
    </div>
  </div>
</template>

<script>
export default {
  name: 'RXResearch',
  props: {
    keys: { type: Array, default: () => [] },
    abstract: { type: String, default: '' }
  },
  data(){ return { showAll:false, maxVisible:4 } },
  computed:{
    visibleKeys(){ return this.showAll ? this.keys : this.keys.slice(0,this.maxVisible) },
    abstractText(){ const div=document.createElement('div'); div.innerHTML = this.abstract || ''; return div.textContent || div.innerText || ''; },
    showMoreAvailable(){ return this.keys.length > this.maxVisible || (this.abstractText && this.abstractText.length > 400) }
  }
}
</script>

<style scoped>
.card{ padding: 8px; border-bottom: 1px solid #eee }
.kstrength{ font-weight:600; white-space:normal; word-break:break-word; font-size:13px }
.krisk{ color:#b00; margin-top:6px; white-space:normal; word-break:break-word; font-size:12px }
.abstract{ margin-top:8px; color:#333; position:relative; overflow:hidden; transition: max-height .25s ease }
.abstract.collapsed{ max-height:100px }
.fade{ position:absolute; left:0; right:0; bottom:0; height:32px; background: linear-gradient(rgba(255,255,255,0), #fff) }
.empty{ color:#777; padding:6px 0 }
.more{ margin-top:6px; background:transparent; border:1px solid #ccc; padding:6px 8px; cursor:pointer }
</style>
